export default __webpack_public_path__ + "static/media/warning--bear-crossing--g2.cddc2568.png";